import React from 'react';
import _ from 'lodash';
import { useUser } from '@lore/auth';
import { Helmet } from 'react-helmet-async';
import { useConnect } from '@lore/query-connect';
import ParentLayout from '../Layout';
import Urls from '../Urls';
import { PayloadStates } from '@lore/utils';
import Loader from '../../../components/Loader';
import Form from './Form';
import useRouter from '../../../hooks/useRouter';
import useSetupNavigation from '../useSetupNavigation';

export default function Layout(props) {
  const { history } = useRouter();

  const user = useUser();

  const navigation = useSetupNavigation(Urls.ORGANIZATION);

  const jobs = useConnect('job.find', {
    where: {
      eager: {
        $where: {
          userId: user.id
        }
      }
    },
    pagination: {
      page: 1,
      pageSize: 100,
      order: 'createdAt asc'
    }
  });

  if (jobs.state === PayloadStates.FETCHING) {
    return (
      <ParentLayout>
        <Helmet>
          <title>Setup - Organization</title>
        </Helmet>
        <Loader />
      </ParentLayout>
    );
  }

  return (
    <ParentLayout>
      <Helmet>
        <title>Setup - Organization</title>
      </Helmet>
      <Form
        user={user}
        jobs={jobs}
        navigation={navigation}
        onPrevious={(newData) => history.push(Urls.PARTNER_VALUE)}
        onNext={() => history.push(Urls.SKILLS_INTRODUCTION)}
        onSkip={() => history.push(Urls.SKILLS_INTRODUCTION)}
      />
    </ParentLayout>
  );
};
